import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateCampaign } from 'supabase/campaigns/mutations'
import { CampaignUpdate } from 'supabase/campaigns/types'
import { notifications } from '@mantine/notifications'

export function useCampaignUpdate() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: CampaignUpdate }) =>
      updateCampaign(id, data),
    onSuccess: () => {
      notifications.show({
        title: 'Success',
        message: 'Campaign updated successfully',
        color: 'green'
      })
      // Invalidate campaign queries to refetch updated data
      queryClient.invalidateQueries({ queryKey: ['campaigns'] })
      // The list key is a different first element, so ['campaigns'] does not match it
      queryClient.invalidateQueries({ queryKey: ['campaigns-with-impressions'] })
      queryClient.invalidateQueries({ queryKey: ['campaign'] })
    },
    onError: (error: Error) => {
      notifications.show({
        title: 'Error',
        message: error.message || 'Failed to update campaign',
        color: 'red'
      })
    }
  })
}